<template>
  <div>
    <div class="ui top attached menu">
      <div class="ui dropdown icon item" ref="module_dropdown">
        <i class="graduation icon"></i>
      </div>
      <div class="ui dropdown icon item">
        {{ course.name }}
      </div>
      <div class="right menu">
        <div class="ui dropdown icon item" ref="order_menu">
          <i class="down angle icon"></i>
          <div class="menu">
            <div class="item" data-value="career_based">
              <i class="users icon"></i
              >{{
                $t("create sections based on career, branch and studying time")
              }}
            </div>
            <!-- <div
              class="item"
              v-for="(section, secidx) in sections"
              :key="secidx"
              :data-value="section.uuid"
            >
              <i class="plus icon"></i>{{ $t("add all to") }} {{ section.name }}
            </div> -->
          </div>
        </div>
        <div class="ui dropdown icon item" @click="toggle">
          <i
            v-bind:class="{
              'expand icon': this.compressed,
              'compress icon': !this.compressed,
            }"
          ></i>
        </div>
        <div class="ui dropdown icon item" @click="add_section">
          <i class="green plus icon"></i>
        </div>
      </div>
    </div>
    <div class="ui bottom attached segment" ref="main_segment">
      <div class="description">
        <div class="ui form">
          <div class="fields">
            <div class="six column wide field">
              <label for="">{{ $t("branch") }}</label>
              <div
                class="ui multiple search selection dropdown"
                ref="branch_dropdown"
              >
                <input type="hidden" name="ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="seven column wide  field">
              <label for="">{{ $t("career") }}</label>
              <div
                class="ui multiple search  selection dropdown"
                ref="career_dropdown"
              >
                <input type="hidden" name="ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="one column wide  field">
              <label for="">{{ $t("search") }}</label>
              <div class="ui blue icon labeled button" @click="search">
                <i class="search icon"></i>
                {{ $t("search") }}
              </div>
            </div>
          </div>
        </div>
        <div class="ui two column grid" v-if="false">
          <div class="column">
            <h4 class="ui dividing header">{{ $t("general") }}</h4>
            <div class="ui list">
              <div
                class="item"
                v-for="(grl, grlidx) in course.setup.general"
                :key="grlidx"
              >
                {{ grl.name }}: {{ grl.value }}
              </div>
            </div>
          </div>
          <div class="column">
            <h4 class="ui dividing header">{{ $t("weighting") }}</h4>
            <div class="ui list">
              <div
                class="item"
                v-for="(wei, weiidx) in course.setup.weighting"
                :key="weiidx"
              >
                {{ wei.name }}: {{ wei.weighting_percent }}%
              </div>
            </div>
          </div>
        </div>
        <div class="" v-show="preinscriptions && preinscriptions.length">
          <h2 class="ui dividing header">
            <i class="users icon"></i>
            <div class="content">
              {{ $t("students distribution") }}
              <small
                >| {{ preinscriptions.length }}
                <span v-if="preinscriptions.length == 1">{{
                  $t("student")
                }}</span>
                <span v-if="preinscriptions.length > 1">{{
                  $t("students")
                }}</span></small
              >
            </div>
          </h2>
          <table
            class="ui striped celled very compact selectable table"
            ref="table"
          >
            <thead>
              <tr>
                <th>{{ $t("student") }}</th>
                <th>{{ $t("career") }}</th>
                <th>{{ $t("branch") }}</th>
                <th>{{ $t("studying time") }}</th>
                <th>{{ $t("section") }}</th>
                <th>{{ $t("options") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in preinscriptions" :key="idx">
                <td>
                  {{ item.std_student.student_id_card }} -
                  {{ item.std_student.name }}
                </td>
                <td>{{ item.std_career.name }}</td>
                <td>{{ item.std_branch.name }}</td>
                <td>{{ item.std_studying_time.name }}</td>
                <td>
                  <div class="ui form">
                    <div class="field">
                      <div class="ui selection dropdown" ref="section_dropdown">
                        <input type="hidden" name="section" />
                        <i class="dropdown icon"></i>
                        <div class="default text">{{ $t("section") }}</div>
                        <div class="menu">
                          <div
                            class="item"
                            v-for="(section, secidx) in sections"
                            :key="secidx"
                            :data-value="section.uuid"
                            :data-preinscribed="item.preinscription_id"
                          >
                            {{ section.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="ui basic mini icon button"
                    @click="remove_preinscription(item)"
                  >
                    <i class="red trash icon"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <h4 class="ui dividing header">
            <i class="users cog icon"></i>
            <div class="content">{{ $t("sections") }}</div>
          </h4>
          <div
            class="ui error icon message"
            v-show="sections && !sections.length"
          >
            <i class="exclamation triangle icon"></i>
            <div class="content">
              <div class="header">
                {{ $t("alert") }}
              </div>
              <p>{{ $t("no sections created yet") }}</p>
            </div>
          </div>

          <div v-if="sections && sections.length">
            <div class="ui top attached tabular menu">
              <a
                ref="section_tab"
                class="item"
                :data-tab="'t_' + section.uuid"
                v-for="(section, secidx) in sections"
                :key="secidx"
                >{{ section.name }} ({{ section.students.length }})</a
              >
            </div>
            <course-section
              class="ui bottom attached olive tab segment"
              :data-tab="'t_' + section.uuid"
              v-for="(section, secidx) in sections"
              :key="secidx"
              @remove="remove_section(secidx)"
              :section="section"
              :course="course"
              :season="season"
              :branches="branches"
              :studying_times="studying_times"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { cloneDeep, groupBy, chunk } from "lodash";
import CourseSection from "./Section";
import { local_api, error_toast, success_toast } from "@/utils";

export default {
  name: "CourseAssignationDistributionCourse",
  components: { CourseSection },
  props: {
    course: Object,
    season: Object,
    careers: Array,
    branches: Array,
    studying_times: Array,
    section_attributes: Array,
    maximum_capacity_auto_section: String,
  },
  data() {
    return {
      sections: [],
      preinscriptions: [],
      career: "",
      branch: "",
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.s,
        },
      ],
      compressed: false,
    };
  },
  computed: {
    // sections() {
    //   let vm = this;
    //   if (vm.course && vm.preinscriptions) {
    //     let groups = groupBy(vm.preinscriptions, function(p) {
    //       let section = p.setup.assigned_to_section;
    //       if (section) return section;
    //       else return "FREE";
    //     });
    //     return groups;
    //   } else return {};
    // },
  },
  mounted() {
    let vm = this;
    vm.init_options_dropdown();
  },
  methods: {
    add_section(/* course */) {
      let vm = this;
      vm.sections.push({
        uuid: v4(),
        name: `${this.$t("section")} ${vm.sections.length}`,
        professor: "",
        students: [],
        attributes: cloneDeep(vm.section_attributes),
        branch: "",
        studying_time: "",
      });
      // if (course && !course.sections) course.sections = [];
      // course.sections.push({
      //   name: this.$t("section") + course.sections.length,
      //   teacher: "",
      //   students: [],
      // });

      // vm.$forceUpdate();
    },
    remove_section(secidx) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove section? this cannot be undone"),
        function() {
          let section = vm.sections[secidx];
          local_api(vm, "post", "/course/section/do-remove", {
            u: section.uuid,
          })
            .then(() => {
              vm.sections.splice(secidx, 1);
              success_toast(vm.$t("section deleted"));
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    search() {
      let vm = this;
      local_api(vm, "post", "/course/assignation/do-get-preinscriptions", {
        b: vm.branch,
        c: vm.career,
        cs: vm.course.course_id,
        s: vm.season.season_id,
      })
        .then((r) => {
          vm.preinscriptions = r.preinscriptions;
          vm.sections = r.sections.map((s) => {
            return {
              uuid: s.uuid,
              name: s.name,
              professor: s.professor_id,
              students: s.setup.students,
              attributes: s.setup.attributes,
              branch: s.branch_id,
              studying_times: s.studying_time_id,
            };
          });
          setTimeout(() => {
            window.jQuery(vm.$refs.table).DataTable();
          }, 300);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    toggle() {
      this.compressed = !this.compressed;
      window.jQuery(this.$refs.main_segment).slideToggle("fast");
    },
    init_dropdowns() {
      let vm = this;
      window
        .jQuery(vm.$refs.career_dropdown)
        .dropdown("setup menu", {
          values: vm.careers.map((c) => {
            return { name: c.name, value: c.career_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.career = value;
          },
        });

      window
        .jQuery(vm.$refs.branch_dropdown)
        .dropdown("setup menu", {
          values: vm.branches.map((b) => {
            return { name: b.name, value: b.branch_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.branch = value;
          },
        });
    },
    remove_preinscription(item) {
      let vm = this;
      vm.$alertify.confirm(
        this.$t("are you sure to remove pre-inscription?"),
        function() {
          local_api(
            vm,
            "post",
            "/course/assignation/do-remove-preinscription",
            {
              u: item.uuid,
            },
          )
            .then(() => {
              success_toast(vm.$t("pre-inscription deleted"));
              vm.search();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    init_options_dropdown() {
      let vm = this;
      window.jQuery(vm.$refs.order_menu).dropdown({
        onChange(value) {
          if (value == "career_based") {
            /**
             * Create section for every career and branch
             */

            let grouped = groupBy(vm.preinscriptions, (p) => {
              return `${p.std_career.name} - ${p.std_branch.name} - ${p.std_studying_time.name}`;
            });

            Object.keys(grouped).map((g) => {
              let sections = chunk(
                grouped[g],
                vm.maximum_capacity_auto_section,
              );

              sections.map((s, i) => {
                vm.sections.push({
                  uuid: v4(),
                  name: `${vm.$t("section")} ${i}`,
                  professor: "",
                  students: s,
                  attributes: cloneDeep(vm.section_attributes),
                  branch: grouped[g][0].std_branch.branch_id,
                  studying_time:
                    grouped[g][0].std_studying_time.studying_time_id,
                });
              });
            });
          } else {
            let trgtSection = vm.sections.find((s) => {
              return s.uuid == value;
            });

            if (trgtSection) {
              console.log(value, trgtSection);
            }
          }
        },
      });
    },
  },
  watch: {
    sections() {
      let vm = this;
      setTimeout(() => {
        window.jQuery(vm.$refs.section_dropdown).dropdown({
          onChange(value, text, $element) {
            let sectionUuid = value;
            let preinscribedId = $element.data("preinscribed");

            let trgtSection = vm.sections.find((s) => {
              return s.uuid == sectionUuid;
            });

            if (trgtSection) {
              let trgtPreinscription = vm.preinscriptions.find((p) => {
                return p.preinscription_id == preinscribedId;
              });

              if (trgtPreinscription) {
                /** Remove from other sections */
                vm.sections = vm.sections.map((s) => {
                  s.students = s.students.filter((st) => {
                    return st.preinscription_id != preinscribedId;
                  });
                  return s;
                });

                /** Add student to section */
                trgtSection.students.push(trgtPreinscription);
              } else {
                console.log("preinscription not found");
              }
            } else {
              console.log("section not found");
            }
          },
        });

        window.jQuery(vm.$refs.section_tab).tab();

        vm.init_options_dropdown();
      }, 200);
    },
  },
};
</script>
